import React, { useEffect } from 'react';
interface CallToActionProps {
  destinationUrl: string;
  buttonText: string;
  productName: string;
  descriptionText?: string;
}
export const CallToAction = ({
  destinationUrl,
  buttonText,
  productName,
  descriptionText
}: CallToActionProps) => {
  const handleClick = () => {
    // Track button click with Facebook Pixel
    if (window.fbq) {
      window.fbq('track', 'Lead', {
        content_name: productName,
        content_category: 'Product Interest'
      });
    }
    // Get fbclid from localStorage if it exists
    const fbclid = localStorage.getItem('fbclid');
    let finalUrl = destinationUrl;
    // Append fbclid to URL if it exists
    if (fbclid) {
      const separator = destinationUrl.includes('?') ? '&' : '?';
      finalUrl = `${destinationUrl}${separator}fbclid=${fbclid}`;
    }
    // Open in new tab
    window.open(finalUrl, '_blank');
  };
  return <div className="my-8 bg-white border border-slate-300 rounded-lg p-6 text-center" data-id="element-2264">
      {descriptionText}
      <button onClick={handleClick} className="w-full bg-slate-900 text-white font-semibold py-4 px-8 rounded-md hover:bg-slate-800 transition-colors text-lg" data-id="element-2265">
        {buttonText}
      </button>
      <p className="text-xs text-slate-500 mt-3" data-id="element-2266">
        Click above to check current availability
      </p>
    </div>;
};